<template>
	<div id="app">
		<Widget />
		<Bizki v-if="client === 'bizki'" />
		<Miniapp />
		<GoogleTranslate />
	</div>
</template>

<script>
	import Widget from './components/Widget';
	import { mapState } from 'vuex';

	import Bizki from './components/clients/Bizki';
	import Miniapp from './components/Miniapp';
	import GoogleTranslate from './components/GoogleTranslate';

	export default {
		components: {
			Widget,
			Bizki,
			Miniapp,
			GoogleTranslate
		},

		computed: {
			...mapState(['client'])
		},

		mounted() {
			document.querySelector('body').setAttribute('data-client', this.client);
		}
	};
</script>

<style scoped lang="scss">
	#app {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		border-radius: 1rem;
	}
</style>
